import React, { CSSProperties } from "react";
import { ICON_TYPES } from "@shared/common/constants";
import { TradeSourceType } from "@shared/types";
import styled, { useTheme } from "styled-components";
import IconWithFallback, {
  IconWithFallbackProps,
} from "Global/IconWithFallback";
import {
  BotsIcon,
  ManualIcon,
  SignalsIcon,
  SignalBotsIcon,
} from "common/Icons/Icons";
import Tooltip from "common/Tooltips/Tooltip";

interface IconWithSourceProps {
  symbol?: string;
  mainIconSize?: number;
  mainImageLink?: string;
  sourceType?: TradeSourceType;
  source?: string;
  sourceImageLink?: string | null;
  style?: CSSProperties;
}

export const IconWithSource = ({
  symbol,
  mainIconSize = 32,
  mainImageLink,
  sourceType,
  source,
  sourceImageLink,
  style,
}: IconWithSourceProps) => {
  const appTheme = useTheme();
  const SourceIcon = sourceType && SOURCE_TYPE_ICON_MAPPING[sourceType];
  const sourceIconSize = Math.max(22, mainIconSize - 10);

  let mainIconProps: IconWithFallbackProps = {
    pxIconSize: mainIconSize,
    iconStyle: { borderRadius: 50 },
  };
  if (mainImageLink) {
    mainIconProps = { ...mainIconProps, iconLink: mainImageLink };
  } else if (symbol) {
    mainIconProps = {
      ...mainIconProps,
      coinOrExchangeName: symbol,
      iconType: ICON_TYPES.COIN,
    };
  }

  const getSource = () => {
    const iconSize = Math.max(sourceIconSize - 8, 16);
    if (sourceImageLink) {
      return <img src={sourceImageLink} width={iconSize} />;
    } else if (SourceIcon) {
      return (
        <SourceIcon
          style={{
            color: appTheme.colors.basic,
            fill: appTheme.colors.basic,
            height: iconSize - 2,
            width: iconSize - 2,
          }}
        />
      );
    }
  };

  const sourceItem = getSource();

  return (
    <div
      style={{
        marginRight: mainIconSize * 0.66,
        position: "relative",
        ...style,
      }}
    >
      <IconWithFallback {...mainIconProps} />
      {sourceItem && (
        <Tooltip title={source} placement="top">
          <SourceTypeWrapper $size={sourceIconSize}>
            {sourceItem}
          </SourceTypeWrapper>
        </Tooltip>
      )}
    </div>
  );
};

const SOURCE_TYPE_ICON_MAPPING: Record<TradeSourceType, any> = {
  [TradeSourceType.GRID_BOT]: BotsIcon,
  [TradeSourceType.DCA_BOT]: BotsIcon,
  [TradeSourceType.MANUAL]: ManualIcon,
  [TradeSourceType.GROUP]: SignalsIcon,
  [TradeSourceType.TRADING_VIEW]: SignalsIcon,
  [TradeSourceType.SIGNALS_BOT]: SignalBotsIcon,
};

export const SourceTypeWrapper = styled.div<{ $size?: number }>`
  background-color: ${(p) =>
    p.theme.isDarkMode ? p.theme.colors.lightestGrey : p.theme.colors.white};
  box-shadow: ${(p) =>
    p.theme.isDarkMode
      ? "#0000003D 0 6px 24px 0"
      : "rgba(0, 0, 0, 0.15) 0 2px 8px"};
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(p) => p.$size}px;
  width: ${(p) => p.$size}px;
  right: -12px;
  bottom: -6px;
`;
